import api from './index'
import request from '@/utils/request'

/**
 * @description 退出
 */
export function logout (query) {
  return request({
    url: `${api.logout}`,
    method: 'get',
    params: query
  })
}
// 代理商系统 交易查询流水查询
/**
 * @description 交易数据查询
 */
export function listDealInfo (data) {
  return request({
    url: `${api.listDealInfo}`,
    method: 'post',
    data
  })
}
/**
* @description 交易数据查询
*/
export function exportDealInfo (data) {
  return request({
    url: `${api.exportDealInfo}`,
    method: 'post',
    data
  })
}
/**
* @description 代理商查询下属商户列表
*/
export function listAgentMerchant (data) {
  return request({
    url: `${api.listAgentMerchant}`,
    method: 'post',
    data
  })
}
// 代理商系统 商户交易统计
/**
 * @description 直属下级代理商信息查看
 */
export function directSubAgentInfo (data) {
  return request({
    url: `${api.directSubAgentInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户交易统计列表
 */
export function mtList (data) {
  return request({
    url: `${api.mtList}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户交易统计导出
 */
export function exportMtList (data) {
  return request({
    url: `${api.exportMtList}`,
    method: 'post',
    data
  })
}
// 商户系统 交易流水查询
/**
 * @description 获取商户编号下拉列表
 */
export function getAllSubMerchantNames (data) {
  return request({
    url: `${api.getAllSubMerchantNames}`,
    method: 'post',
    data
  })
}
/**
 * @description 交易订单查询
 */
export function listMerchantTrans (data) {
  return request({
    url: `${api.listMerchantTrans}`,
    method: 'post',
    data
  })
}
/**
 * @description 交易订单查询导出
 */
export function exportMerchantTrans (data) {
  return request({
    url: `${api.exportMerchantTrans}`,
    method: 'post',
    data
  })
}
// 商户系统 总分店交易统计报表
/**
 * @description 总分店交易统计报表
 */
export function getTransStatistic (data) {
  return request({
    url: `${api.getTransStatistic}`,
    method: 'post',
    data
  })
}
/**
 * @description 总分店交易统计报表导出
 */
export function exportTransStatistic (data) {
  return request({
    url: `${api.exportTransStatistic}`,
    method: 'post',
    data
  })
}
/**
 * @description 机构交易查询
 */
export function listTradeDetail (data) {
  return request({
    url: `${api.listTradeDetail}`,
    method: 'post',
    data
  })
}
/**
 * @description 机构交易导出
 */
export function exportTradeDetail (data) {
  return request({
    url: `${api.exportTradeDetail}`,
    method: 'post',
    data
  })
}
/**
 * @description 套餐订单列表
 */
export function listPackageOrderInfo (data) {
  return request({
    url: `${api.listPackageOrderInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 交易流水查询
 */
export function queryTradeFlowData (data) {
  return request({
    url: `${api.queryTradeFlowData}`,
    method: 'post',
    data
  })
}
/**
 * @description 智掌柜交易流水导出
 */
export function exportTradeFlowData (data) {
  return request({
    url: `${api.exportTradeFlowData}`,
    method: 'post',
    data
  })
}
